<template>
  <div class="outer dashboard-page">

    <span class="display-1">Hello Admin!</span>
    <br />
    <span class="subtitle">Where you want to go?</span>

    <sections-list />

  </div>
</template>


<script>
import sectionsList from "@/components/sections-list";
export default {
  components: { sectionsList },
  mounted() {
    //fetch data from DB
  }
};
</script>

<style>
.dashboard-page .v-list {
  background: none;
}
.dashboard-page .v-list .v-list__tile {
  background: white;
  border: 5px solid rgb(250, 250, 250);
  border-left: 0;
  border-right: 0;
  padding: 0 2rem;
  height: 4.5rem;
}
@media (min-width: 768px) {
  .dashboard-page .v-list {
    margin-top: 20px;
  }

  .dashboard-page .v-list .v-list__tile {
    border: 5px solid rgb(250, 250, 250);
    height: 6rem;
    width: 50%;
    float: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/DashboardPage.vue